/*
 * Future dev note,
 * the values needs to match the subdomain from Auth
 */
export enum ComplianceFormQuestionGroup {
  MAIN = 'main',
  WESTFIELD = 'westfieldcarrier',
  TRAVELERS = 'travelers',
  ATTUNE = 'attuneoffplatform',
}

export interface IComplianceResponse {
  created_at: any;
  data: CompliancePayload;
  id?: string;
  tenant_id: string;
  updated_at: any;
  completed_question_groups: Array<ComplianceFormQuestionGroup>;
}

type CompliancePayloadValue = string | string[] | number | boolean | null;

export type CompliancePayload = {
  [key: string]:
    | CompliancePayloadValue
    | { [key: string]: CompliancePayloadValue };
};
